import React, {useState, useEffect, useContext, useRef} from 'react'
import styled from 'styled-components';
import { UserContext } from '../../context/context';
import '../SignIn/SignIn.scss'
import './Profile.scss'
import Select from 'react-select';
import { rankOptions, abilityOptions, fieldOptions, SMfieldOptions, ITfieldOptions, BMfieldOptions, freshOptions, interestOptions, SMjobOptions, ITjobOptions, BMjobOptions, tagOptions, languageOptions, schoolOptions, majorOptions, degreeOptions, companyOptions, paperOptions, lookOptions, yearOptions, monthOptions } from '../SignIn/data';
import CreatableSelect from 'react-select/creatable';

function Profile() {

  // resume가 두개 이상일떄
  // awards는 input이 여러개 추가되는 형식, 이 추가되는 형식은 school이랑 work에서도
  // school, work 여러개일떄 쪼개서 어레이에 넣고 하기

  let user = JSON.parse(String(localStorage.getItem('user')))

  let email = String(localStorage.getItem('email'))
  const header = {Authorization: `JWT ${user.token}`}

  const [state, actions] = useContext(UserContext);
  const [basicData, setBasicData] = useState()
  const [applyData, setApplyData] = useState()
  const [resume, setResume] = useState()
  const [school, setSchool] = useState()
  const [work, setWork] = useState()
  const [paperPaper, setPaperPaper] = useState()
  
  const inputFile = useRef(null) 
  const [selectedFile, setSelectedFile] = useState();
	const [isFilePicked, setIsFilePicked] = useState(false);

  const [imgurl, setImgurl] = useState(state.noimage)

  const [applylist, setApplylist] = useState()


  const [activate, setActivate] = useState({

    "realname": null,
    "realemail" : null,
    "realbirth": null,
    "realphone": null,

    "look": null,
    "intro": null,
    "field": null,
    "tools": null,
    "abilities": null,
    "interests": null,
    "domain": null,
    "tag": null,
    "field": null,
    "job": null,
    "fresh": null,
    "wholeWork": null,
    "languages": null,
    "awards": null,
    "patents": null,
    "sal": null,

    "strength": null,
    "school": null,
    "work": null,
    "paperPaper": null,

  })



  // basic
  const [abilities, setAbilities] = useState([])
  const [interests, setInterests] = useState([])
  const [tag, setTag] = useState([])
  const [domain, setDomain] = useState([])
  const [field, setField] = useState()
  const [job, setJob] = useState()
  const [fresh, setFresh] = useState(null)
  const [lookjob, setLookjob] = useState()
  const [lookcons, setLookcons] = useState()

  const [currentsal, setCurrentsal] = useState()
  const [expectedsal, setExpectedsal] = useState()

  const [realname, setRealname] = useState()
  const [realemail, setRealemail] = useState()
  const [realphone, setRealphone] = useState()
  const [realbirth, setRealbirth] = useState()
  const [address, setAddress] = useState()


  // resume
  const [intro, setIntro] = useState()
  const [tools, setTools] = useState([])
  const [wholeWork, setWholeWork] = useState()
  const [languages, setLanguages] = useState([])
  const [awards, setAwards] = useState([])
  const [tempawards, setTempwards] = useState([])

  const [resumeOptions, setResumeOptions] = useState()
  const [whichResume, setWhichResume] = useState(0)
  const [patents, setPatents] = useState([])
  const [temppatents, setTemppatents] = useState([])

  const [strength, setStrength] = useState()

  // school
  const [edit, setEdit] = useState()
  const [title, setTitle] = useState()
  const [major, setMajor] = useState()
  const [degree, setDegree] = useState()
  const [prof, setProf] = useState()
  const [paper, setPaper] = useState()
  const [startY, setStartY] = useState()
  const [startM, setStartM] = useState()
  const [endY, setEndY] = useState()
  const [endM, setEndM] = useState()

  // work
  const [workEdit, setWorkEdit] = useState()
  const [workTitle, setWorkTitle] = useState()
  const [workJob, setWorkJob] = useState()
  const [workDepart, setWorkDepart] = useState()
  const [workStartY, setWorkStartY] = useState()
  const [workStartM, setWorkStartM] = useState()
  const [workEndY, setWorkEndY] = useState()
  const [workEndM, setWorkEndM] = useState()
  const [workMemo, setWorkMemo] = useState()
  const [workYoN, setWorkYoN] = useState(false)

  // paper
  const [paperTitle, setPaperTitle] = useState()
  const [paperJournal, setPaperJournal] = useState()
  const [paperAuthur, setPaperAuthur] = useState()
  const [paperCoAuthur, setPaperCoAuthur] = useState()
  const [paperYear, setPaperYear] = useState()
  const [status, setStatus] = useState()

  const [save, setSave] = useState(false)
  
  const [whichjobOptions, setWhichjobOptions] = useState(SMjobOptions)

  useEffect(()=>{

    async function fetchBasicData(){
      const res =  fetch(state.awslink + "/user/userIntAbi/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setBasicData(json)
        setAbilities(json.abilities)
        setInterests(json.interests)
        setDomain(json.domain)
        setField(json.field)
        if(json.field){
          if(SMfieldOptions.filter((item)=>item.value === json.field).length){
            let index = SMfieldOptions.findIndex((item)=>item.value===json.field)
            setWhichjobOptions(SMjobOptions[index])
          }
          else if(ITfieldOptions.filter((item)=>item.value === json.field).length){
            let index = ITfieldOptions.findIndex((item)=>item.value===json.field)
            setWhichjobOptions(ITjobOptions[index])
          }
          else if(BMfieldOptions.filter((item)=>item.value === json.field).length){
            let index = BMfieldOptions.findIndex((item)=>item.value===json.field)
            setWhichjobOptions(BMjobOptions[index])
          } 
        }
        setJob(json.job)
        setFresh(json.fresh)
        setLookjob(json.lookjob)
        setLookcons(json.lookcons)

        setExpectedsal(json.expectedSal)
        setCurrentsal(json.currentSal)

        setRealname(json.realname)
        setRealemail(json.realmail)
        setRealbirth(json.realbirth)
        setRealphone(json.realphone)

        setImgurl(json.profilelink + "?dummy=000")
      })
    }
    
    async function fetchSchoolData(){
      const res =  fetch(state.awslink + "/user/school/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        // console.log(json)
        setSchool(json)
      })
    }

    async function fetchWorkData(){
      const res =  fetch(state.awslink + "/user/work/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{setWork(json)})
    }
    
    async function fetchResumeData(){
      const res =  fetch(state.awslink + "/api/resume/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        // setResume(json)
        if(json.length){
          setResume(json[json.length-1])
          setIntro(json[json.length-1].intro || null)
          setStrength(json[json.length-1].strength || null)
          setLanguages(json[json.length-1].languages || [])
          setTools(json[json.length-1].tools || [])
          setAwards(json[json.length-1].awards || [])
          setPatents(json[json.length-1].patents || [])

          setWholeWork(json[json.length-1].wholeWork || null) 
          setTag(json[json.length-1].tag)
        }
        let newobj = [];
        if(json.length)
          json.map((item, index)=>{
            newobj.push({"value": index, "label": index, "id": item.id})
          })

        setResumeOptions(newobj)
        

      })
    }

    async function fetchPaperData(){
      const res =  fetch(state.awslink + "/api/paper/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        setPaperPaper(json)
      })
        
    }

    

    // if(!basicData)  
    fetchBasicData();    
    // if(!resume)  
    fetchResumeData();
    // if(school===[])  
    fetchSchoolData();
    // if(work===[])  
    fetchWorkData();
    fetchPaperData();

    async function fetchApplylist(){
      fetch(state.awslink + "/api/apply/", {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        if(json){
          console.log(json)
        }
        setApplylist(json)
      
        
        
      }
      )
    }
    fetchApplylist()
    

  }, [])


  function activateObj(index){
    let tempObj = {}
    for (const [key, value] of Object.entries(activate)) {
      if(index === "null") tempObj[`${key}`] = null
      else if(key === index) tempObj[`${key}`] = true
      else tempObj[`${key}`] = false
    }
    setActivate(tempObj)
  }

  const handleChange = (func) => e => {
    // console.log(func)
    func(Array.isArray(e) ? e.map(x => x.value) : [])
  }

  const handleChangeArr = (func, val, check) =>{
    // console.log(func)
    // oldArray => [...oldArray, item.author["email"]])
    if(check)
      func(oldArray => [...oldArray, val])
    else
      func([val])
    // func(Array.isArray(val) ? e.map(x => x.value) : [])

    return val
  }

  function handleDefault(index) {
    let tempObj=[];
    if(index)
      index.map((item)=>{tempObj.push({value:item, label:item})})
    return(tempObj)
  }

  function fetchSchoolPost(){
    
    if(edit) {
      fetch(state.awslink + "/user/school/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": edit.id,
          "title": title || edit.title,
          "major": major || edit.major,
          "degree": degree || edit.degree,
          "prof": prof || edit.prof || null ,
          "paper": paper || edit.paper,
          "start": edit.start ? edit.start : (startY + "/" + startM),
          "end": edit.end ? edit.end : (endY + "/" + endM),
        })
      })
      .then(response => response.json())
      .then(json=>{
        let edited = school.filter((item)=> item.id === edit.id)
        // console.log(edited)
        edited[0].title = title || edit.title
        edited[0].major = major || edit.major
        edited[0].degree = degree || edit.degree
        edited[0].prof = prof || edit.prof
        edited[0].paper = paper || edit.paper
        edited[0].start = edit.start ? edit.start : (startY + "/" + startM)
        edited[0].end = edit.end ? edit.end : (endY + "/" + endM)

        // console.log(school)
        setSchool(json)

        setEdit();
      })
    }
    else {
      fetch(state.awslink + "/user/school/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": title,
          "major": major,
          "degree": degree,
          "prof": prof || null,
          "paper": paper,
          "start": startY + "/" + startM,
          "end": endY + "/" + endM,
        })
      })
      .then(response => response.json())
      .then(json=>{
        setSchool(oldArray => [...oldArray, {
          "title": title,
          "major": major,
          "degree": degree,
          "prof": prof || null,
          "paper": paper,
          "start": startY + "/" + startM,
          "end": endY + "/" + endM,
        }])

        // console.log(school)
        setSchool(json)
        setEdit();

      })
    }
  }

  function fetchWorkPost(){

    console.log(workTitle, workDepart, workMemo, workJob)
    console.log(edit)
    if(edit) {
      fetch(state.awslink + "/user/work/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": edit.id,
          "title": workTitle || edit.title,
          "job": workJob || edit.job,
          "depart": workDepart || edit.depart,
          "memo": workMemo || edit.memo,
          "start": edit.start ? edit.start : (workStartY + "/" + workStartM),
          "end": edit.end ? edit.end : (workEndY + "/" + workEndM) || null,
        })
      })
      .then(response => response.json())
      .then(json=>{
        let edited = work.filter((item)=> item.id === edit.id)
        // console.log(edited)
        edited[0].title = workTitle || edit.title
        edited[0].job = workJob || edit.job
        edited[0].depart = workDepart || edit.depart
        edited[0].memo = workMemo || edit.memo
        edited[0].start = edit.start ? edit.start : (workStartY + "/" + workStartM)
        edited[0].end = edit.end ? edit.end : (workEndY + "/" + workEndM)
        
        setWork(json)
        setEdit();
      })
    }
    else {
      fetch(state.awslink + "/user/work/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": workTitle,
          "job": workJob,
          "depart": workDepart || null,
          "memo": workMemo || null,
          "start": workStartY + "/" + workStartM,
          "end": workEndY + "/" + workEndM || null,
        })
      })
      .then(response => response.json())
      .then(json=>{
        setWork(oldArray => [...oldArray, {
          "title": workTitle,
          "job": workJob,
          "depart": workDepart || null,
          "memo": workMemo,
          "start": workStartY + "/" + workStartM,
          "end": workEndY + "/" + workEndM || null,
        }])

        // console.log(work)
        setWork(json)
        setEdit();

      })
    }
  }

  function fetchResumePost(){
    console.log(resume)
    // console.log(intro,abilities,interests,tag,tools,wholeWork,languages,awards)
    if(resume) {
      // console.log(resume[0].id)
      // console.log(resume)
      fetch(state.awslink + "/api/resume/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": resume.id,
          "title": "기본",
          "intro": intro || null,
          "abilities": abilities || null,
          "interests": interests || null,
          "tag": tag || null,
          "domain": domain || null,
          "tools": tools || null,
          "wholeWork": wholeWork || null,
          "languages": languages || null,
          "awards": tempawards && tempawards.length ? [tempawards] : null,
          "patents": temppatents && temppatents.length ? [temppatents] : null,
          "strength": strength || null,
        })
      })
      .then(response => response.json())
      .then(json=>{
        // let edited = work.filter((item)=> item.id === edit.id)
        
        // setEdit();t
        setResume(json)
        setSave(false)
        // window.location.reload();
      })
    }
    else {
      fetch(state.awslink + "/api/resume/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "intro": intro || null,
          "title": "기본",
          "abilities": abilities || null,
          "interests": interests || null,
          "tag": tag || null,
          "domain": domain || null,
          "tools": tools || null,
          "wholeWork": wholeWork || null,
          "languages": languages || null,
          "awards": tempawards && tempawards.length ? [tempawards] : null,
          "patents": temppatents && temppatents.length ? [temppatents] : null,
          "strength": strength || null,
        })
      })
      .then(response => response.json())
      .then(json=>{
        setResume(json)
        setSave(false)
        // window.location.reload();
        
      })
    }
  }

  function fetchPaperPost(){
    
    if(edit) {
      fetch(state.awslink + "/api/paper/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": edit.id,
          "paperTitle": paperTitle || edit.paperTitle,
          "paperJournal": paperJournal || edit.paperJournal,
          "paperAuthur": paperAuthur || edit.paperAuthur,
          // "paperCoAuthur": paperCoAuthur || edit.paperCoAuthur,
          "paperCoAuthur": null,
          "paperYear": paperYear || edit.paperYear,
          "status": status || edit.status,
        })
      })
      .then(response => response.json())
      .then(json=>{
        let edited = paperPaper.filter((item)=> item.id === edit.id)
        edited[0].paperTitle = paperTitle || edit.paperTitle
        edited[0].paperJournal = paperJournal || edit.paperJournal
        edited[0].paperAuthur = paperAuthur || edit.paperAuthur
        edited[0].paperCoAuthur = null
        edited[0].paperYear = paperYear || edit.paperYear
        edited[0].status = status || edit.statu
        

        // console.log(school)
        // setSchool(school)
        setEdit();
        setPaperPaper(json)
      })
    }
    else {
      fetch(state.awslink + "/api/paper/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "paperTitle": paperTitle,
          "paperJournal": paperJournal,
          "paperAuthur": paperAuthur,
          // "paperCoAuthur": paperCoAuthur,
          "paperCoAuthur": null,
          "paperYear": paperYear,
          "status": status,
        })
      })
      .then(response => response.json())
      .then(json=>{
        // setPaperPaper(oldArray => [...oldArray, {
        //   "paperTitle": paperTitle,
        //   "paperJournal": paperJournal,
        //   "paperAuthur": paperAuthur,
        //   // "paperCoAuthur": paperCoAuthur,
        //   "paperCoAuthur": null,
        //   "paperYear": paperYear,
        //   "status": status,
        // }])

        // console.log(school)
        setPaperPaper(json)
        setEdit();



      })
    }
  }

  function fetchDelete(which, id){
    console.log(id)
    fetch(state.awslink  + which, {
      method: 'DELETE',
      headers: header,
      body:JSON.stringify({
        "id": id
      })
    })
    .then(response => response.json())
    .then(json=>{
      if(which === "/user/school/"){
        setSchool(json)
      }
      else if(which === "/user/work/"){
        setWork(json)
      }
      else if(which === "/api/paper/"){
        setPaperPaper(json)
      }
    })
  }

  function fetchLookPut(){
    fetch(state.awslink  + "/user/userBasic/", {
      method: 'PUT',
      headers: header,
      body:JSON.stringify({
        "lookjob": lookjob || null,
        "lookcons": lookcons || null,
      })
    })
    .then(response => response.json())
    .then(json=>{})
  }

  function fetchUserBasic(){
    console.log(field, job, fresh)
    
    // if(edit){
    fetch(state.awslink + "/user/userBasic/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "field": field || null,
        "job": job || null,
        "fresh": fresh || null,

        "realname": realname || null,
        "realmail": realemail || null,
        "realphone": realphone ||  null,
        "realbirth": realbirth || null,

        "currentSal": currentsal || null,
        "expectedSal": expectedsal || null,
      })
    })
    .then(response => response.json())
    .then(json=>{
      console.log(json)
    })
  }

  function fetchResumeDelete(id, index, which){
    let awardsBool = false
    let patentsBool = false

    if(which === "awards")  awardsBool=true
    else                    patentsBool = true

    fetch(state.awslink + "/api/resume/", {
      method: 'DELETE',
      headers: header,
      body:JSON.stringify({
        "id": id,
        "awards": awardsBool,
        "patents": patentsBool,
        "index": index
      })
    })
    .then(response => response.json())
    .then(json=>{
      setResume(json)
    })
  }

  const changeHandler = (event, whichimg) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
    // console.log("changeHandler")
    handleSubmission(event.target.files[0], whichimg)

	};

  const handleSubmission = (file, whichimg) => {
    // console.log("handleSubmission")
    // console.log(file)
		const formData = new FormData();
    formData.append('file', file,  whichimg + '.' + file.name.split('.')[file.name.split('.').length-1]);
    
		fetch(
			state.awslink + "/api/file/?" + whichimg + "=true",
			{
				method: 'POST',
        headers: header,
				body: formData,
			}
		)
			.then((response) => response.json())
			.then((result) => {
				console.log('Success:', result);

        setIsFilePicked()
        setImgurl(result.file + "?dummy=123")
			})
			.catch((error) => {
				console.error('Error:', error);
			});
    
	};

  const onButtonClick = (whichimg) => {
    inputFile.current.click();
  };


  function yearSelectorStart(yset, mset, y, m){
    return(
      <YearWrapper>
        <Select
          className="profile-basic-date"
          defaultValue={edit? {value: edit.start.split('/')[0], label: edit.start.split('/')[0]}: null}
          isSearchable={true}
          name="color"
          options={yearOptions}
          onChange={(e)=>{
            if(e.value) yset(e.value)
            if(edit) edit.start = e.value + '/' + (edit.start.split('/')[1] || m)
          }}
        />
        <Select
          className="profile-basic-date-month"
          defaultValue={edit? {value: edit.start.split('/')[1], label: edit.start.split('/')[1]}: null}
          isSearchable={true}
          name="color"
          options={monthOptions}
          onChange={(e)=>{
            if(e.value) mset(e.value);
            if(edit) edit.start = (edit.start.split('/')[0] || y) + '/' + e.value
          }}
        />
      </YearWrapper>
      )
    }  

  function yearSelectorEnd(yset, mset, y, m){
    return(
      <YearWrapper>
        <Select
          className="profile-basic-date"
          defaultValue={edit? {value: edit.end.split('/')[0], label: edit.end.split('/')[0]}: null}
          isSearchable={true}
          name="color"
          options={yearOptions}
          onChange={(e)=>{
            if(e.value) yset(e.value)
            if(edit) edit.end = e.value + '/' + (edit.end.split('/')[1] || m)
          }}
        />
        <Select
          className="profile-basic-date-month"
          defaultValue={edit? {value: edit.end.split('/')[1], label: edit.end.split('/')[1]}: null}
          isSearchable={true}
          name="color"
          options={monthOptions}
          onChange={(e)=>{
            if(e.value) mset(e.value);
            if(edit) edit.end = (edit.end.split('/')[0] || y) + '/' + e.value 
          }}
        />
      </YearWrapper>
      )
    }  
  
  const removeJob = (option) => {
    let newSelect = job
    
    if(job && job.length){
      job.map((item, index)=>{
        if(!option.includes({value: item, label: item})){
          newSelect = []
        }
      })
      setJob(newSelect)
    }
  };

  console.log(workTitle, workJob)
  return(
    <>
        {state.width < state.breakpoint ? 
            null
            :   
            <Wrapper>
                <MidWrapper>
                    
                    <RightWrapper>
                      {/* {basicData && resume && school && work && paperPaper? */}
                      <>
                        <ImgWrapper>
                          <img 
                            src = {imgurl ? imgurl : "dummy"} 
                            onError={(e)=> {
                              e.target.src = state.noimage
                            }}
                            onClick={()=>onButtonClick("profile")}
                            style={{cursor: "pointer" }}
                          />
                          <input 
                            type="file" 
                            name="file" 
                            ref={inputFile} 
                            onChange={(e)=>{changeHandler(e, "profile"); console.log("onChange")}} 
                            style={{ display: "none" }}/>
                        </ImgWrapper>

                        <h3>기본정보</h3>

                        {/* Realname */}
                        <span className={activate.realname===false ? "deactivate": "activate"}>
                          <h4>이름</h4>
                          <WriteEditForm>
                          {realname ?
                            <>
                              <div className="ras-text">
                                {activate.realname? null : realname} 
                              </div>
                              {activate.realname ? null : <button onClick={()=>activateObj("realname")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.realname ? null : <button onClick={()=>activateObj("realname")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          
                          {activate.realname?
                          <AfterForm>
                            <input className="profile-basic-input" value={realname} onChange={(e)=>setRealname(e.target.value)}/>
                            <AfterBtnForm>
                            <button onClick={()=>{activateObj("null"); setRealname(realname)}}>취소</button>
                            <button onClick={()=>{activateObj("null"); setSave(true); fetchUserBasic()}}>저장</button>
                          </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        {/* Realemail */}
                        <span className={activate.realemail===false ? "deactivate": "activate"}>
                          <h4>이메일</h4>
                          <WriteEditForm>
                          {realemail ?
                            <>
                              <div className="ras-text">
                                {activate.realemail? null : realemail} 
                              </div>
                              {activate.realemail ? null : <button onClick={()=>activateObj("realemail")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.realemail ? null : <button onClick={()=>activateObj("realemail")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          
                          {activate.realemail?
                          <AfterForm>
                          <input className="profile-basic-input" value={realemail} onChange={(e)=>setRealemail(e.target.value)}/>
                          <AfterBtnForm>
                          <button onClick={()=>{activateObj("null"); setRealemail(realemail)}}>취소</button>
                          <button onClick={()=>{activateObj("null"); setSave(true); fetchUserBasic()}}>저장</button>
                          </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>
                        
                        {/* Realphone */}
                        <span className={activate.realphone===false ? "deactivate": "activate"}>
                          <h4>폰번호</h4>
                          <WriteEditForm>
                          {realphone ?
                            <>
                              <div className="ras-text">
                                {activate.realphone? null : realphone} 
                              </div>
                              {activate.realphone ? null : <button onClick={()=>activateObj("realphone")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.realphone ? null : <button onClick={()=>activateObj("realphone")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          
                          {activate.realphone?
                          <AfterForm>
                          <input className="profile-basic-input" value={realphone} onChange={(e)=>setRealphone(e.target.value)}/>
                          <AfterBtnForm>
                          <button onClick={()=>{activateObj("null"); setRealphone(realphone)}}>취소</button>
                          <button onClick={()=>{activateObj("null"); setSave(true); fetchUserBasic()}}>저장</button>
                          </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        {/* Realbirth */}
                        <span className={activate.realbirth===false ? "deactivate": "activate"}>
                          <h4>출생년도</h4>
                          <WriteEditForm>
                          {realbirth ?
                            <>
                              <div className="ras-text">
                                {activate.realbirth? null : realbirth} 
                              </div>
                              {activate.realbirth ? null : <button onClick={()=>activateObj("realbirth")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.realbirth ? null : <button onClick={()=>activateObj("realbirth")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          
                          {activate.realbirth?
                          <AfterForm>
                          <input className="profile-basic-input" value={realbirth} onChange={(e)=>setRealbirth(e.target.value)}/>
                          <AfterBtnForm>
                          <button onClick={()=>{activateObj("null"); setRealbirth(realbirth)}}>취소</button>
                          <button onClick={()=>{activateObj("null"); setSave(true); fetchUserBasic()}}>저장</button>
                          </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>
                        
                        {/* Address */}

                        <div className="devider"></div>

                        
                        <h3>전문분야설정</h3>
                        {/* Field / Job */}
                        <span className={activate.field===false ? "deactivate": "activate"}>
                          <h4>직군/직무</h4>
                          <WriteEditForm>
                            {field&&job ?
                              <>
                                <div className="ras-text">
                                  {field} - {job}
                                </div>
                                {activate.field ? null : 
                                <button onClick={()=>activateObj("field")}>
                                <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                              </>
                              : activate.field ? null : <button onClick={()=>activateObj("field")}>
                                <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                              </button>
                            }
                          </WriteEditForm>
                          {activate.field?
                          <AfterForm>
                            <Select
                              className="profile-basic-single"
                              defaultValue={{ value: field, label: field}}
                              isSearchable={true}
                              name="color"
                              options={fieldOptions}
                              onChange={(e)=>{
                                if(e.value) {
                                  setField(e.value)
                                  if(SMfieldOptions.filter((item)=>item.value === e.value).length){
                                    let index = SMfieldOptions.findIndex((item)=>item.value===e.value)
                                    setWhichjobOptions(SMjobOptions[index])
                                    removeJob(SMjobOptions[index])
                                  }
                                  else if(ITfieldOptions.filter((item)=>item.value === e.value).length){
                                    let index = ITfieldOptions.findIndex((item)=>item.value===e.value)
                                    setWhichjobOptions(ITjobOptions[index])
                                    removeJob(ITjobOptions[index])
                                  }
                                  else if(BMfieldOptions.filter((item)=>item.value === e.value).length){
                                    let index = BMfieldOptions.findIndex((item)=>item.value===e.value)
                                    setWhichjobOptions(BMjobOptions[index])
                                    removeJob(BMjobOptions[index])
                                  } 
                                }
                              }}
                            />
                            <Select
                              // className="basic-single"
                              defaultValue={handleDefault(job)}
                              className="profile-basic-multi"
                              isMulti
                              isSearchable={true}
                              name="color"
                              options={whichjobOptions}
                              value={handleDefault(job)}
                              onChange={(e)=>{setJob(Array.isArray(e) ? e.map(x => x.value) : [])}}
                            />
                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setJob(job); setField(field);}}>취소</button>
                              <button onClick={()=>{activateObj("null"); fetchUserBasic();}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        {/* Abilities */}
                        <span className={activate.abilities===false ? "deactivate": "activate"}>
                          <h4>기술/도구</h4>
                          <WriteEditForm>
                          {abilities && abilities.length ?
                            <>

                              {abilities.map((item)=>{
                                return(
                                  <div className="ras-tag">{item}</div>
                                )
                              })}
                              {activate.abilities ? null : <button onClick={()=>activateObj("abilities")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.abilities ? null : <button onClick={()=>activateObj("abilities")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                          }
                          </WriteEditForm>
                          {activate.abilities?
                          <AfterForm>
                            <CreatableSelect
                              defaultValue={handleDefault(abilities)}
                              className="profile-basic-multi"
                              isMulti
                              options={abilityOptions}
                              onChange={handleChange(setAbilities)}
                            />
                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setAbilities(abilities);}}>취소</button>
                              <button onClick={()=>{activateObj("null"); setSave(true); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        {/* Domain */}
                        <span className={activate.domain===false ? "deactivate": "activate"}>
                          <h4>도메인</h4>
                          <WriteEditForm>
                          {domain && domain.length ?
                            <>
                              {domain.map((item)=>{
                                return(
                                  <div className="ras-tag">{item}</div>
                                )
                              })}
                              {activate.domain ? null : <button onClick={()=>activateObj("domain")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.domain ? null : <button onClick={()=>activateObj("domain")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          
                          {activate.domain?
                          <AfterForm>
                            <CreatableSelect
                              defaultValue={handleDefault(domain)}
                              className="profile-basic-multi"
                              isMulti
                              options={interestOptions}
                              onChange={handleChange(setDomain)}
                            />
                            <AfterBtnForm>
                            <button onClick={()=>{activateObj("null"); setDomain(domain);}}>취소</button>
                            <button onClick={()=>{activateObj("null"); setSave(true); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        <div className="devider"></div>
                        
                        <h3>관심사항설정</h3>

                        {/* Tag */}
                        <span className={activate.tag===false ? "deactivate": "activate"}>
                          <h4>태그</h4>
                          <WriteEditForm>
                          {tag && tag.length ?
                            <>
                              {tag.map((item)=>{
                                return(
                                  <div className="ras-tag">{item}</div>
                                )
                              })}
                              {activate.tag ? null : <button onClick={()=>activateObj("tag")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.tag ? null : <button onClick={()=>activateObj("tag")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          
                          {activate.tag?
                          <AfterForm>
                            <Select
                              defaultValue={handleDefault(tag)}
                              className="profile-basic-multi"
                              isMulti
                              options={tagOptions}
                              onChange={handleChange(setTag)}
                            />
                            <AfterBtnForm>
                            <button onClick={()=>{activateObj("null"); setTag(tag);}}>취소</button>
                            <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        {/* Interests */}
                        <span className={activate.interests===false ? "deactivate": "activate"}>
                          <h4>관심분야</h4>
                          <WriteEditForm>
                          {interests && interests.length ?
                            <>
                              {interests.map((item)=>{
                                return(
                                  <div className="ras-tag">{item}</div>
                                )
                              })}
                              {activate.interests ? null : <button onClick={()=>activateObj("interests")}>
                                <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.interests ? null : <button onClick={()=>activateObj("interests")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          
                          {activate.interests?
                          <AfterForm>
                            <CreatableSelect
                              defaultValue={handleDefault(interests)}
                              className="profile-basic-multi"
                              isMulti
                              options={interestOptions}
                              onChange={handleChange(setInterests)}
                            />
                            <AfterBtnForm>
                            <button onClick={()=>{activateObj("null"); setInterests(interests);}}>취소</button>
                            <button onClick={()=>{activateObj("null"); setSave(true); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        
                        <div className="devider"></div>
                        

                        {/* Fresh */}
                        <span className={activate.fresh===false ? "deactivate": "activate"}>
                          <h4>신입/경력</h4>
                          <WriteEditForm>
                          {fresh ?
                            <>
                              <div className="ras-text">
                                {fresh}
                              </div>
                              {activate.fresh ? null : <button onClick={()=>activateObj("fresh")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.fresh ? null : <button onClick={()=>activateObj("fresh")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          {activate.fresh?
                          <AfterForm>
                            <Select
                              className="profile-basic-single"
                              defaultValue={{ value: fresh, label: fresh}}
                              isSearchable={true}
                              name="color"
                              options={freshOptions}
                              onChange={(e)=>{if(e.value) setFresh(e.value)}}
                            />
                            <AfterBtnForm>
                            <button onClick={()=>{activateObj("null"); }}>취소</button>
                            <button onClick={()=>{activateObj("null"); setSave(true);  fetchUserBasic()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        {/* Whole Work */}
                        <span className={activate.wholeWork===false ? "deactivate": "activate"}>
                          <h4>상세경력</h4>
                          <WriteEditForm>
                          {wholeWork ?
                            <>
                              <div className="ras-text">
                                {wholeWork}년
                              </div>
                              {activate.wholeWork ? null : <button onClick={()=>activateObj("wholeWork")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.wholeWork ? null : <button onClick={()=>activateObj("wholeWork")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          
                          {activate.wholeWork?
                          <AfterForm>
                          <input className="profile-basic-input" value={wholeWork} onChange={(e)=>setWholeWork(e.target.value)}/>
                          <AfterBtnForm>
                          <button onClick={()=>{activateObj("null"); setWholeWork(wholeWork)}}>취소</button>
                          <button onClick={()=>{activateObj("null"); setSave(true); fetchResumePost()}}>저장</button>
                          </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>
                        
                        {/* Languages */}
                        <span className={activate.languages===false ? "deactivate": "activate"}>
                          <h4>언어</h4>
                          <WriteEditForm>
                          {languages.length ?
                            <>
                              {languages.map((item)=>{
                                return(
                                  <div className="ras-tag">{item}</div>
                                )
                              })}
                              {activate.languages ? null : <button onClick={()=>activateObj("languages")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                            </>
                            : activate.languages ? null : <button onClick={()=>activateObj("languages")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                            </button>
                          }
                          </WriteEditForm>
                          {activate.languages?
                          <AfterForm>
                            <Select
                              defaultValue={handleDefault(languages)}
                              className="profile-basic-multi"
                              isMulti
                              options={languageOptions}
                              onChange={handleChange(setLanguages)}
                            />
                            <AfterBtnForm>
                            <button onClick={()=>{activateObj("null"); setLanguages(languages);}}>취소</button>
                            <button onClick={()=>{activateObj("null"); setSave(true); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        {/* Awards */}
                        <span className={activate.awards===false ? "deactivate": "activate"}>
                          <h4>수상</h4>
                          <WriteEditForm>
                            {resume && resume.awards ?
                            
                              <>
                                <div className="ras-li">
                                  {resume.awards.map((item, index)=>{
                                    return(
                                      <>
                                      <div>
                                        {item}
                                        <button 
                                        onClick={()=>{
                                          console.log(index)
                                          // resume.awards.splice(index, 1);
                                          fetchResumeDelete(resume.id, index, "awards")
                                        }
                                        }>X</button>
                                      </div>
                                      
                                      </>
                                    )
                                  })}
                                </div>
                              </>
                              : 
                              awards? 
                                <div className="ras-li">
                                    {awards.map((item)=>{
                                      return(
                                        <div>
                                          {item}
                                        </div>
                                      )
                                    })}
                                  </div>
                                  :null
                            }
                           
                          </WriteEditForm>
                          {activate.awards?
                          <AfterForm>
                            <input className="profile-basic-input" value={tempawards} onChange={(e)=>{setTempwards(e.target.value)}}/>
                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null");}}>취소</button>
                              <button onClick={()=>{activateObj("null"); setSave(true); 
                                handleChangeArr(setAwards, tempawards, awards); 
                                setTempwards(); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :
                          <>
                            <AddBtn onClick={()=>activateObj("awards")}>추가하기</AddBtn>
                          </>
                          }
                           
                        </span>

                        {/* Patents */}
                        <span className={activate.patents===false ? "deactivate": "activate"}>
                          <h4>특허</h4>
                          <WriteEditForm>
                            {resume && resume.patents ?
                              <>
                                <div className="ras-li">
                                  {resume.patents.map((item, index)=>{
                                    return(
                                      <>
                                      <div>
                                        {item}
                                        <button 
                                        onClick={()=>{
                                          console.log(index)
                                          // resume.patents.splice(index, 1);
                                          fetchResumeDelete(resume.id, index, "patents")
                                        }
                                        }>X</button>
                                      </div>
                                      
                                      </>
                                    )
                                  })}
                                </div>
                              </>
                              : 
                              patents? 
                                <div className="ras-li">
                                    {patents.map((item)=>{
                                      return(
                                        <div>
                                          {item}
                                        </div>
                                      )
                                    })}
                                  </div>
                                  :null
                            }
                           
                          </WriteEditForm>
                          {activate.patents?
                          <AfterForm>
                            <input className="profile-basic-input" value={temppatents} onChange={(e)=>{setTemppatents(e.target.value)}}/>
                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null");}}>취소</button>
                              <button onClick={()=>{activateObj("null"); setSave(true); 
                                handleChangeArr(setPatents, temppatents, patents); 
                                setTemppatents(); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :
                          <>
                            <AddBtn onClick={()=>activateObj("patents")}>추가하기</AddBtn>
                          </>
                          }
                           
                        </span>

                        {/* Sal */}
                        <span className={activate.sal===false ? "deactivate": "activate"}>
                          <h4>연봉</h4>
                          <WriteEditForm>
                            {currentsal || expectedsal ?
                              <>
                                <div className="ras-text">
                                    <div>현재: {currentsal}</div>
                                    <div>희망: {expectedsal}</div>
                                </div>
                                {activate.sal ? null : <button onClick={()=>activateObj("sal")}>
                                  <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                              </>
                              : 
                              <>
                                <div className="ras-text">
                                    <div>현재: -</div>
                                    <div>희망: -</div>
                                </div>
                              {activate.sal ? null : <button onClick={()=>activateObj("sal")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                              </>
                            }
                           
                          </WriteEditForm>
                          {activate.sal?
                          <AfterForm>
                            <input className="profile-basic-input" value={currentsal} onChange={(e)=>{setCurrentsal(e.target.value)}}/>
                            <input className="profile-basic-input" value={expectedsal} onChange={(e)=>{setExpectedsal(e.target.value)}}/>
                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null");}}>취소</button>
                              <button onClick={()=>{activateObj("null"); setSave(true); fetchUserBasic()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :
                          null
                          // <>
                          //   <AddBtn onClick={()=>activateObj("sal")}>추가하기</AddBtn>
                          // </>
                          }
                           
                        </span>
                        

                        <div className="devider"></div>
                        
                        <h3>이력서</h3>

                        {/* Strength */}
                        <span className={activate.strength===false ? "deactivate": "activate"}>
                          <h4>특장점</h4>
                          {/* <WriteEditForm> */}
                          {strength ?
                            <> 
                              {activate.strength ? null : 
                              <WriteEditForm> 
                                <div className="ras-text">
                                  <p>
                                    {strength}
                                  </p> 
                                </div>
                                <button onClick={()=>activateObj("strength")}>
                                <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button> 
                              </WriteEditForm>}
                            </>
                            : activate.strength ? null : 
                              <WriteEditForm>
                              <button onClick={()=>activateObj("strength")}>
                                <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                              </button>
                              </WriteEditForm>
                          }
                          {/* </WriteEditForm> */}
                          
                          {activate.strength?
                          <AfterForm>
                            <textarea className="profile-basic-ta" value={strength} onChange={(e)=>setStrength(e.target.value)}/>
                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setStrength(strength)}}>취소</button>
                              <button onClick={()=>{activateObj("null"); setSave(true); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                        {/* School */}
                        <span className={activate.school===false ? "deactivate": "activate"}>
                          <h4>학력</h4>
                          {school ?
                            <SchoolForm >
                              {school.map((item, index)=>{
                                // console.log(item); 
                                if(edit === item){
                                  return (
                                    <SchoolEditForm>
                                      <div className="sub-devider"></div>
                                      <span>
                                        <div>
                                          학교이름
                                          <CreatableSelect
                                            className="profile-basic-single"
                                            defaultValue={edit? {value: edit.title, label: edit.title}: null}
                                            isSearchable={true}
                                            name="color"
                                            options={schoolOptions}
                                            onChange={(e)=>setTitle(e.value)}
                                            // onInputChange={arraySet(index, title)}
                                              // setTitle(e.value)}}
                                          />
                                        </div>
                                      </span>
                                      <span>
                                        <div>
                                          전공
                                        <CreatableSelect
                                            className="profile-basic-single"
                                            defaultValue={edit? {value: edit.major, label: edit.major}: null}
                                            isSearchable={true}
                                            name="color"
                                            options={majorOptions}
                                            onChange={(e)=>setMajor(e.value)}
                                          />
                                        </div>
                                      </span>
                                          
                                      <span>
                                        <div>
                                          학위
                                          <Select
                                            className="profile-basic-single"
                                            defaultValue={edit? {value: edit.degree, label: edit.degree}: null}
                                            isSearchable={true}
                                            name="color"
                                            options={degreeOptions}
                                            onChange={(e)=>{if(edit) {setDegree(e.value); edit.degree = e.value} else{setDegree(e.value)}}}
                                          />
                                        </div>
                                      </span>
                                          {degree === undefined && edit === undefined ? null : 
                                              edit ? 
                                                edit.degree==="학사 과정" || edit.degree==="학사 졸업" ?
                                                null: 
                                                <span>
                                                  <div>
                                                    지도교수
                                                    <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                                  </div>
                                                </span>  
                                              : 
                                              degree === "학사 과정" || degree === "학사 졸업" ?
                                              null
                                              :
                                              <span>
                                                  <div>
                                                    지도교수
                                                    <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                                  </div>
                                                </span>  
                                          }

                                          <span>
                                            <div>
                                              연구주제
                                            <input className="profile-basic-input" value={edit? edit.paper: paper} onChange={(e)=>{setPaper(e.target.value); if(edit) edit.paper=e.target.value}}/>
                                            </div>
                                          </span>

                                          {
                                            degree === undefined && edit === undefined ? null : 
                                              edit ? 
                                                edit.degree==="학사 과정" || edit.degree==="석사 과정" || edit.degree === "박사(통합) 과정" ?
                                                  <>
                                                    {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                                  </>
                                                  :
                                                  <>

                                                    {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                                    {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                                  </>
                                                :
                                                degree==="학사 과정" || degree==="석사 과정" || degree === "박사(통합) 과정"?
                                                  <>
                                                    {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                                  </>
                                                  :
                                                  <>
                                                    {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                                    {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                                  </>
                                          }
                                          
                                      <AfterBtnForm>
                                      <button onClick={()=>{activateObj("null"); setTitle(); setMajor(); setPaper(); setDegree(); setProf(); setStartY(); setStartM(); setEndY(); setEndM(); setEdit()}}>취소</button>
                                      <button onClick={()=>{activateObj("null"); fetchSchoolPost(); setSave(true) }}>저장</button>
                                      </AfterBtnForm>
                                      <div className="sub-devider"></div>
                                    </SchoolEditForm>
                                  )
                                } else{
                                  return(
                                  <div>
                                    <h4>
                                      {item.title}
                                      {activate.school ? null : 
                                      <>
                                        <button onClick={()=>{activateObj("school"); setEdit(item);}}>
                                          <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                                        </button>
                                        <button onClick={()=>{fetchDelete("/user/school/", item.id)}}>
                                          X
                                        </button>
                                      </>}
                                    </h4>

                                    <div className={"qu-add"}>
                                      {item.major}
                                    </div>

                                    <div className={"qu-add"}>
                                      {item.degree} 
                                      {item.degree === "박사(통합) 과정" || item.degree === "박사(통합) 졸업" || item.degree === "석사 과정" || item.degree === "석사 졸업"
                                      ? " / " + item.prof: null}
                                    </div>

                                    <div className={"qu-add"}>
                                      {item.start}
                                      {item.end !== "undefined/undefined" 
                                      && " - " + item.end}
                                    </div>

                                    {/* EditorState? */}
                                    <div className={"ras-work-memo"}>
                                      <p>{item.paper}</p>
                                    </div>

                                    
                                  </div>
                                  )}})}
                            </SchoolForm>
                            : <AddBtn onClick={()=>activateObj("school")}>추가하기</AddBtn>
                          }

                          {activate.school && edit === undefined ? 
                            <SchoolEditForm>
                              <div className="sub-devider"></div>
                              <span>
                                <div>
                                  학교이름
                                  <CreatableSelect
                                    className="profile-basic-single"
                                    defaultValue={edit? {value: edit.title, label: edit.title}: null}
                                    isSearchable={true}
                                    name="color"
                                    options={schoolOptions}
                                    onChange={(e)=>setTitle(e.value)}
                                    // onInputChange={arraySet(index, title)}
                                      // setTitle(e.value)}}
                                  />
                                </div>
                              </span>
                              <span>
                                <div>
                                  전공
                                <CreatableSelect
                                    className="profile-basic-single"
                                    defaultValue={edit? {value: edit.major, label: edit.major}: null}
                                    isSearchable={true}
                                    name="color"
                                    options={majorOptions}
                                    onChange={(e)=>setMajor(e.value)}
                                  />
                                </div>
                              </span>
                                  
                              <span>
                                <div>
                                  학위
                                  <Select
                                    className="profile-basic-single"
                                    defaultValue={edit? {value: edit.degree, label: edit.degree}: null}
                                    isSearchable={true}
                                    name="color"
                                    options={degreeOptions}
                                    onChange={(e)=>{if(edit) {setDegree(e.value); edit.degree = e.value} else{setDegree(e.value)}}}
                                  />
                                </div>
                              </span>
                                  {degree === undefined && edit === undefined ? null : 
                                      edit ? 
                                        edit.degree==="학사 과정" || edit.degree==="학사 졸업" ?
                                        null: 
                                        <span>
                                          <div>
                                            지도교수
                                            <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                          </div>
                                        </span>  
                                      : 
                                      degree === "학사 과정" || degree === "학사 졸업" ?
                                      null
                                      :
                                      <span>
                                          <div>
                                            지도교수
                                            <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                          </div>
                                        </span>  
                                  }

                                  <span>
                                    <div>
                                      연구주제
                                    <input className="profile-basic-input" value={edit? edit.paper: paper} onChange={(e)=>{setPaper(e.target.value); if(edit) edit.paper=e.target.value}}/>
                                    </div>
                                  </span>

                                  {
                                    degree === undefined && edit === undefined ? null : 
                                      edit ? 
                                        edit.degree==="학사 과정" || edit.degree==="석사 과정" || edit.degree === "박사(통합) 과정" ?
                                          <>
                                            {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                          </>
                                          :
                                          <>
                                            {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                            {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                          </>
                                        :
                                        degree==="학사 과정" || degree==="석사 과정" || degree === "박사(통합) 과정"?
                                          <>
                                            {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                          </>
                                          :
                                          <>
                                            {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                            {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                          </>
                                  }
                                  
                              <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setTitle(); setMajor(); setPaper(); setDegree(); setProf(); setStartY(); setStartM(); setEndY(); setEndM(); setEdit()}}>취소</button>
                              <button onClick={()=>{activateObj("null"); fetchSchoolPost(); setSave(true) }}>저장</button>
                              </AfterBtnForm>
                              <div className="sub-devider"></div>
                            </SchoolEditForm>
                            :   
                          <>
                            <AddBtn onClick={()=>activateObj("school")}>추가하기</AddBtn>
                          </>
                          // null
                          }
                          
                        </span>
  
                        {/* Work */}
                        <span className={activate.work===false ? "deactivate": "activate"}>
                          <h4>직장</h4>
                          {work ?
                            <SchoolForm className={"ras-work"}>
                              {work.map((item, index)=>{
                                // console.log(item); 
                                if(edit === item){
                                  return (
                                    <SchoolEditForm>
                                      <div className="sub-devider"></div>
                                      <span>
                                        <div>
                                          직장이름
                                          <CreatableSelect
                                            className="profile-basic-single"
                                            defaultValue={edit? {value: edit.title, label: edit.title}: null}
                                            isSearchable={true}
                                            name="color"
                                            options={companyOptions}
                                            onChange={(e)=>setWorkTitle(e.value)}
                                            // onInputChange={arraySet(index, title)}
                                              // setTitle(e.value)}}
                                          />
                                        </div>
                                      </span>

                                      <span>
                                        <div>
                                          부서
                                          <input className="profile-basic-input" value={edit? edit.depart: workDepart} onChange={(e)=>{setWorkDepart(e.target.value); if(edit) edit.depart=e.target.value}}/>
                                        </div>
                                      </span>

                                      <span>
                                        <div>
                                          직급
                                        <CreatableSelect
                                            className="profile-basic-single"
                                            defaultValue={edit? {value: edit.job, label: edit.job}: null}
                                            isSearchable={true}
                                            name="color"
                                            options={rankOptions}

                                            onChange={(e)=>setWorkJob(e.value)}
                                          />
                                        </div>
                                      </span>

                                      

                                      {yearSelectorStart(setWorkStartY, setWorkStartM, workStartY, workStartM)}

                                      <input type='checkbox' onChange={()=>setWorkYoN(!workYoN)}></input>

                                      {workYoN? null:
                                      yearSelectorEnd(setWorkEndY, setWorkEndM, workEndY, workEndM)
                                      }
                                      
                                      
                                      <span className="write-memo">
                                        <div>
                                          Memo
                                          <textarea className="profile-basic-ta" value={edit? edit.memo : workMemo} onChange={(e)=>{setWorkMemo(e.target.value); if(edit) edit.memo = e.target.value}}/>
                                        </div>
                                      </span>

                                      <AfterBtnForm>
                                        <button onClick={()=>{activateObj("null"); setWorkTitle(); setWorkDepart(); setWorkJob(); setWorkStartM(); setWorkStartY(); setWorkEndY(); setWorkEndM(); setWorkMemo(); setEdit()}}>취소</button>
                                        <button onClick={()=>{activateObj("null"); fetchWorkPost(); setSave(true) }}>저장</button>
                                      </AfterBtnForm>
                                      <div className="sub-devider"></div>
                                    </SchoolEditForm>
                                  )
                                } else{
                                  return(
                                  <div>
                                    <h4>
                                      {item.title}
                                      {activate.work ? null : 
                                      <>
                                        <button onClick={()=>{activateObj("work"); setEdit(item); console.log(item)}}>
                                          <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                                        </button>
                                        <button onClick={()=>{fetchDelete("/user/work/", item.id)}}>
                                          X
                                        </button>
                                      </>
                                      }
                                    </h4>

                                    <div className={"qu-add"}>
                                      {item.depart} / {item.job}
                                    </div>
                                    
                                    <div className={"qu-add"}>
                                      {item.start} ~ {item.end}
                                    </div>
                                    
                                    <div className={"ras-work-memo"}>
                                      <p>{item.memo}</p>
                                    </div>
                                    {/* {activate.work ? null : <button onClick={()=>{activateObj("work"); setEdit(item); console.log(item)}}>
                                      수정하기</button>} */}
                                  </div>)}})}

                              
                            </SchoolForm>
                            : <AddBtn onClick={()=>activateObj("work")}>추가하기</AddBtn>
                          }

                          {activate.work && !edit ?     
                            <SchoolEditForm>
                              <div className="sub-devider"></div>
                              <span>
                                <div>
                                  직장이름
                                  <CreatableSelect
                                    className="profile-basic-single"
                                    defaultValue={edit? {value: edit.title, label: edit.title}: null}
                                    isSearchable={true}
                                    name="color"
                                    options={companyOptions}
                                    onChange={(e)=>setWorkTitle(e.value)}
                                    // onInputChange={arraySet(index, title)}
                                      // setTitle(e.value)}}
                                  />
                                </div>
                              </span>

                              <span>
                                <div>
                                  부서
                                  <input className="profile-basic-input" value={edit? edit.depart: workDepart} onChange={(e)=>{setWorkDepart(e.target.value); if(edit) edit.depart=e.target.value}}/>
                                </div>
                              </span>

                              <span>
                                <div>
                                  직급
                                <CreatableSelect
                                    className="profile-basic-single"
                                    defaultValue={edit? {value: edit.job, label: edit.job}: null}
                                    isSearchable={true}
                                    name="color"
                                    options={rankOptions}

                                    onChange={(e)=>setWorkJob(e.value)}
                                  />
                                </div>
                              </span>

                              
                              {yearSelectorStart(setWorkStartY, setWorkStartM, workStartY, workStartM)}

                              <input type='checkbox' onChange={()=>setWorkYoN(!workYoN)}></input>

                              {workYoN? null:
                                yearSelectorEnd(setWorkEndY, setWorkEndM, workEndY, workEndM)
                              }
                              
                              
                              <span className="write-memo">
                                <div>
                                  메모
                                  <textarea className="profile-basic-ta" value={edit? edit.memo : workMemo} onChange={(e)=>{setWorkMemo(e.target.value); if(edit) edit.memo = e.target.value}}/>
                                </div>
                              </span>

                              <AfterBtnForm>
                                <button onClick={()=>{activateObj("null"); setWorkTitle(); setWorkDepart(); setWorkJob(); setWorkStartM(); setWorkStartY(); setWorkEndY(); setWorkEndM(); setWorkMemo(); setEdit()}}>취소</button>
                                <button onClick={()=>{activateObj("null"); fetchWorkPost(); setSave(true) }}>저장</button>
                              </AfterBtnForm>
                              <div className="sub-devider"></div>
                            </SchoolEditForm>
                            :   
                            <>
                              <AddBtn onClick={()=>activateObj("work")}>추가하기</AddBtn>
                            </>
                          }
                          
                        </span>
                        
                        {/* Paper */}
                        <span className={activate.paperPaper===false ? "deactivate": "activate"}>
                          <h4>논문</h4>
                          {paperPaper ?
                            <SchoolForm className={"ras-work"}>
                              {paperPaper.map((item, index)=>{
                                // console.log(item); 
                                if(edit === item){
                                  return (
                                    <SchoolEditForm>
                                      <div className="sub-devider"></div>
                                      <span>
                                        <div>
                                          제목
                                          <input className="profile-basic-input" value={edit? edit.paperTitle: paperTitle} onChange={(e)=>{setPaperTitle(e.target.value); if(edit) edit.paperTitle=e.target.value}}/>
                                        </div>
                                      </span>
                                      
                                      <span>
                                        <div>
                                          저널
                                          <input className="profile-basic-input" value={edit? edit.paperJournal: paperJournal} onChange={(e)=>{setPaperJournal(e.target.value); if(edit) edit.paperJournal=e.target.value}}/>
                                        </div>
                                      </span>
                                          
                                      <span>
                                        <div>
                                          저자
                                          <input className="profile-basic-input" value={edit? edit.paperAuthur: paperAuthur} onChange={(e)=>{setPaperAuthur(e.target.value); if(edit) edit.paperAuthur=e.target.value}}/>
                                        </div>
                                      </span>
                                        {/* <span>
                                          <div>
                                            공저자
                                          <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                          </div>
                                        </span>   */}
                                        
                                        
                                        {/* <span>
                                          <div>
                                            년도
                                          <input className="profile-basic-input" value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>
                                          </div>
                                        </span> */}
                                        
                                      <span>
                                        <div>
                                          상태
                                          <Select
                                            className="profile-basic-single"
                                            defaultValue={edit? {value: edit.status, label: edit.status}: null}
                                            isSearchable={true}
                                            name="color"
                                            options={paperOptions}
                                            onChange={(e)=>setStatus(e.value)}
                                            // onInputChange={arraySet(index, title)}
                                              // setTitle(e.value)}}
                                          />
                                        </div>
                                      </span>
                                      
                                      {/* {yearSelectorStart()} */}
                                      <YearWrapper>
                                        <input className="profile-basic-input" style={{width: 80}} value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>년 
                                      </YearWrapper>

                                      <AfterBtnForm>
                                        <button onClick={()=>{activateObj("null"); setPaperTitle(); setPaperAuthur(); setPaperCoAuthur(); setPaperJournal(); setPaperYear(); setStatus(); setEdit()}}>취소</button>
                                        <button onClick={()=>{activateObj("null"); fetchPaperPost(); setSave(true) }}>저장</button>
                                      </AfterBtnForm>
                                        
                                      <div className="sub-devider"></div>
                                    </SchoolEditForm>
                                  )
                                } else{
                                  return(
                                  <div>
                                    <h4 style={{fontSize: ".9rem"}}>
                                      {item.paperTitle}
                                      {activate.paperPaper ? null : 
                                      <>
                                        <button onClick={()=>{activateObj("paperPaper"); setEdit(item); console.log(item)}}>
                                          <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                                        </button>
                                        <button onClick={()=>{fetchDelete("/api/paper/", item.id)}}>
                                          X
                                        </button>
                                        </>
                                      }
                                    </h4>
                                    <div className="qu-add"> {item.paperJournal} {item.paperAuthur} {item.paperCoAuthur} {item.paperYear} {item.status}</div>
                                    <div className="ras-work-memo"></div>
                                  </div>)}})}

                              {activate.paperPaper ? null :   
                              <>
                                {/* {school.map((item)=>{ return(
                                  <button onClick={()=>{activateObj("school"); setEdit(item); console.log(item)}}>수정하기</button>
                                )})} */}
                                <AddBtn onClick={()=>activateObj("paperPaper")}>추가하기</AddBtn>
                              </>
                              }
                            </SchoolForm>
                            : <AddBtn onClick={()=>activateObj("paperPaper")}>추가하기</AddBtn>
                          }
                          
                          {activate.paperPaper && !edit ?
                          <SchoolEditForm>
                            <div className="sub-devider"></div>
                            <span>
                              <div>
                                제목
                                <input className="profile-basic-input" value={edit? edit.paperTitle: paperTitle} onChange={(e)=>{setPaperTitle(e.target.value); if(edit) edit.paperTitle=e.target.value}}/>
                              </div>
                            </span>
                            
                            <span>
                              <div>
                                저널
                                <input className="profile-basic-input" value={edit? edit.paperJournal: paperJournal} onChange={(e)=>{setPaperJournal(e.target.value); if(edit) edit.paperJournal=e.target.value}}/>
                              </div>
                            </span>
                                
                            <span>
                              <div>
                                저자
                                <input className="profile-basic-input" value={edit? edit.paperAuthur: paperAuthur} onChange={(e)=>{setPaperAuthur(e.target.value); if(edit) edit.paperAuthur=e.target.value}}/>
                              </div>
                            </span>
                              {/* <span>
                                <div>
                                  공저자
                                <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                </div>
                              </span>   */}
                              
                              
                              {/* <span>
                                <div>
                                  년도
                                <input className="profile-basic-input" value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>
                                </div>
                              </span> */}
                              
                            <span>
                              <div>
                                상태
                                <Select
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.status, label: edit.status}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={paperOptions}
                                  onChange={(e)=>setStatus(e.value)}
                                  // onInputChange={arraySet(index, title)}
                                    // setTitle(e.value)}}
                                />
                              </div>
                            </span>
                            
                            {/* {yearSelectorStart()} */}
                            <YearWrapper>
                              <input className="profile-basic-input" style={{width: 80}} value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>년 
                            </YearWrapper>

                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setPaperTitle(); setPaperAuthur(); setPaperCoAuthur(); setPaperJournal(); setPaperYear(); setStatus(); setEdit()}}>취소</button>
                              <button onClick={()=>{activateObj("null"); fetchPaperPost(); setSave(true) }}>저장</button>
                            </AfterBtnForm>
                              
                            <div className="sub-devider"></div>
                          </SchoolEditForm>
                          :null
                          }
                        </span>


                        {/* Intro */}
                        <span className={activate.intro===false ? "deactivate": "activate"}>
                          <h4>자기소개</h4>
                          {/* <WriteEditForm> */}
                          {intro ?
                            <> 
                              {activate.intro ? null : 
                              <WriteEditForm> 
                                <div className="ras-text">
                                  <p>
                                    {intro}
                                  </p> 
                                  </div> 
                                <button onClick={()=>activateObj("intro")}>
                                <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button> 
                              </WriteEditForm>}
                            </>
                            : activate.intro ? null : 
                              <WriteEditForm>
                              <button onClick={()=>activateObj("intro")}>
                                <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                              </button>
                              </WriteEditForm>
                          }
                          {/* </WriteEditForm> */}
                          
                          {activate.intro?
                          <AfterForm>
                            <textarea className="profile-basic-ta" value={intro} onChange={(e)=>setIntro(e.target.value)}/>
                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setIntro(intro)}}>취소</button>
                              <button onClick={()=>{activateObj("null"); setSave(true); fetchResumePost()}}>저장</button>
                            </AfterBtnForm>
                          </AfterForm>
                          :null
                          }
                        </span>

                      </>
                      {/* : null} */}
                    </RightWrapper>

                    <LeftWrapper>
                      <div>
                       <h4>지원현황</h4>
                        {applylist? 
                          <Board>
                            <div>
                              <div>
                                <div>
                                  {applylist.filter(item=>item.step==="지원완료").length}
                                </div>
                                <p>지원완료</p>
                              </div>
                            </div>
                            <div>
                              <div>
                                <div>
                                  {applylist.filter(item=>item.step==="추천").length}
                                </div>
                                <p>추천완료</p>
                              </div>
                            </div>
                            <div>
                              <div>
                                <div>
                                  {applylist.filter(item=>item.step==="서류합격").length}
                                </div>
                                <p>서류합격</p>
                              </div>
                            </div>
                            <div>
                              <div>
                                <div>
                                  {applylist.filter(item=>item.step==="최종합격").length}
                                </div>
                                <p>최종합격</p>
                              </div>
                            </div>
                          </Board>
                          : null}
                      </div>

                      <div>
                       <h4>제안현황</h4>
                        {applylist? 
                          <Board>
                            <div>
                              <div>
                                <div>
                                  {applylist.filter(item=>item.step==="제안보냄" || item.step==="추천제안").length}
                                </div>
                                <p>받은제안</p>
                              </div>
                            </div>
                            <div>
                              <div>
                                <div>
                                  {applylist.filter(item=>item.step==="제안수락").length}
                                </div>
                                <p>제안수락</p>
                              </div>
                            </div>
                            <div>
                              <div>
                                <div>
                                  {applylist.filter(item=>item.step==="검토").length}
                                </div>
                                <p>원해요</p>
                              </div>
                            </div>
                            <div>
                              <div>
                                <div>
                                  {applylist.filter(item=>item.step==="임시").length}
                                </div>
                                <p>임시</p>
                              </div>
                            </div>
                          </Board>
                          : null}
                      </div>

                      <div>
                        {basicData ?
                        <>
                          {/* <button className={save ? "activate": "deactivater"} onClick={()=>{fetchResumePost(); fetchUserBasic();}}>
                            저장하기
                          </button> */}
                          <div>
                            <h4>프로필 완성도
                              
                            </h4>
                            
                            
                            <div>
                              <h4>전문영역설정</h4>
                            </div>

                            <div>
                              <h4>관심사항설정</h4>
                            </div>

                            <div>
                              <h4>이력서작성</h4>
                            </div>

                          </div>

                          <div className="devider"></div>

                          <div>
                            <h4>리크루터 공개여부
                            {activate.look ? null : 
                            <button onClick={()=>activateObj("look")}>
                              <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                            }

                            </h4>
                            

                            {lookjob && lookcons && activate.look === null? 
                            <>
                              <div>
                                {lookjob === "0" && "적극적으로 찾는 중"}
                                {lookjob === "1" && "당장은 생각이 없지만 고려해볼 것"}
                              </div>
                            </>: null
                            }

                            {activate.look?
                              <AfterForm>
                                <Select
                                  className="profile-basic-single"
                                  defaultValue={lookOptions.filter((item)=>item.value===lookjob)}
                                  isSearchable={true}
                                  name="color"
                                  options={lookOptions}
                                  onChange={(e)=>{if(e.value) setLookjob(e.value)}}
                              />
                              </AfterForm>
                            : null}
                            
                          </div>

                          <div>
                            <h4>자문 공개여부</h4>

                            {lookjob && lookcons && activate.look === null? 
                            <>
                              <div>
                                {lookcons === "0" && "적극적으로 찾는 중"}
                                {lookcons === "1" && "당장은 생각이 없지만 고려해볼 것"}

                              </div>
                            </>: null
                            }
                            
                            {activate.look?
                            <AfterForm>
                              {/* <Select
                                className="profile-basic-single"
                                defaultValue={lookOptions.filter((item)=>item.value===lookjob)}
                                isSearchable={true}
                                name="color"
                                options={lookOptions}
                                onChange={(e)=>{if(e.value) setLookjob(e.value)}}
                              /> */}
                              <Select
                                className="profile-basic-single"
                                defaultValue={lookOptions.filter((item)=>item.value===lookcons)}
                                isSearchable={true}
                                name="color"
                                options={lookOptions}
                                onChange={(e)=>{if(e.value) setLookcons(e.value)}}
                              />
                              <AfterBtnForm>
                                <button onClick={()=>{activateObj("null"); }}>취소</button>
                                <button onClick={()=>{activateObj("null"); fetchLookPut();}}>저장</button>
                              </AfterBtnForm>
                            </AfterForm>
                            :null
                            }
                            
                          </div>
                          <div className="devider"></div>

                        </>
                        : null}
                      </div>
                    </LeftWrapper>

                </MidWrapper>
            </Wrapper>   
        }
    </>
  )
}

export default Profile;

const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 45px);

  margin-top: 45px;

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`
const MidWrapper = styled.div`
  display: flex;
  width: 90%;
  max-width: 1060px;
  height: 100%;
  justify-content: center;
  align-items: flex-start;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: row;
`

const LeftWrapper = styled.div`
    display: flex;
    width: 29%;
    margin-left: 1%;
    min-height: 90%;
    position: relative;
    height: auto;
    margin-top: 20px;
    background-color: inherit;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;

    >div{
      position: relative;
      /* left: 5%; */
      width: 100%;
      height: calc(90% - 45px);

      box-sizing: border-box;
      padding: 20px;

      margin-bottom: 10px;

      @media only screen and (max-width: 1060px){
        /* left: 5%; */
        width: 100%;
      }
      
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align:left;

      border-radius: 5px;
      >h4{
        font-size: 1rem;
        margin: 0;
        margin-bottom: 10px;
      }
      .devider{
        display: block;
        width: 100%;
        height: 1px;
        margin-top: 10px;
        margin-bottom: 10px;
        border-top: 1px solid rgba(0,0,0,0.2);
      }

      >button{
        background-color: transparent;
        border: .5px solid rgba(0,102,204,.8);
        border-radius: 5px;
        color: rgba(0,102,204,.8);
        box-sizing: border-box;
        width: 100%;
        padding: 10px;
        opacity: .8;
        transition: .2s;
        margin-bottom: 20px;
        font-size: 1rem;
        cursor: pointer;
        :hover{
          background-color: rgba(0,102,204,.1);
          opacity: 1;
        }
      }

      .deactivater{
        cursor: not-allowed;
        opacity: .4;
        /* background-color: rgba(0,102,204,.6); */
        :hover{
          background-color: transparent;
          opacity: .4;
        }
      }

      .activate{
        cursor: pointer;
        opacity: 1;
        font-weight: bold;
        /* background-color: rgba(0,102,204,.6); */
      }
      
      >div{
        /* margin-top: 5px; */
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        h4{
          font-size: 1rem;
          margin: 0;
          margin-bottom: 10px;
          button{
            border: none;
            background-color: transparent;
            opacity: .8;
            transition: .2s;
            cursor: pointer;
            :hover{
              opacity: 1;
            }
          }

          .deactivate{
            cursor: not-allowed;
            opacity: .2;
          }
        }

        >div{
          margin: 0;
          
          h4{
            font-size: .9rem;  
          }
        }
      }
    }
`

const Board = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  margin: 0;
  margin-top: 20px;
  margin-bottom: 0;
  flex-direction: row !important;
  >div{
    display: flex;
    width: 100%;
    margin: 0;

    >div{
      display: flex;
      flex-direction: column;
      width: 100%;
      >div{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.4rem;
      }
      p{
        font-size: .7rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
    }
    
  }

`

const RightWrapper = styled.div`
    display: flex;
    width: 70%;
    margin-right: 1%;
    min-height: 90%;
    position: relative;
    top: 20px;
    height: auto;
    /* border: red solid; */
    background-color: white;

    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    box-sizing: border-box;
    padding: 20px;

    border-radius: 5px;
    h3{
      :first-child{
        margin-top: 0px;
      }
      font-size: 1rem;
    }

    > span{
    /* background-color: red; */
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      margin-bottom: 20px;
      width: 100%;
      
      padding-left: 10px;
      box-sizing: border-box;
      font-size: .9rem;
      h4{
        margin: 0;
        padding-top: 20px;
        padding-bottom: 20px;
        font-weight: 600;
        opacity: .6;
      }
      .profile-basic-single .profile-basic-multi{
        width: 400px;
        margin-top: 5px;
        margin-bottom: 5px;
      }
      
    }
    
    .devider{
      display: block;
      width: 100%;
      height: 1px;
      margin-bottom: 10px;
      border-top: 1px solid rgba(0,0,0,0.2);
    }
`

const ImgWrapper=styled.div`
  display: flex;
  height: 200px;
  width: 100%;

  justify-content: center;
  align-items: center;

  >img{
    width: 80px;
    height: 80px;
    border-radius: 50px;
  }

`

const YearWrapper=styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  >input{
    margin-right: 5px;
    margin-left: 10px;
    :first-child{
      margin-left: 0px;
    }
  }
`

const SchoolForm=styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;


  >div{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;

    margin-bottom: 20px;

    .ras-work-memo{
      font-size: .9rem;
      margin-top: 5px;
      /* margin-bottom: 20px; */
      >p{
        white-space: pre-line;
        margin: 0;
        text-align:left;
        width: 100%;
        height: 100%;
      }
    }

    h4{
      font-weight: 500;
      /* font-size: .9rem; */
      font-size: 1.1rem;
      padding-top: 0px;
      padding-bottom: 5px;
      opacity: 1;
      position: relative;
      width: 100%;
      text-align: left;
      button{
        border: none;
        background-color: transparent;
        opacity: .4;
        transition: .2s;
        cursor: pointer;
        position: absolute;
        padding: 0px;
        right: 30px;
        :hover{
          opacity: 1;
        }
        :last-child{
          right: 10px;
        }
      }
    }
    
  }
`

const SchoolEditForm =styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  /* margin-left: 10px; */

  margin-top: 10px;
  margin-bottom: 10px;

  box-sizing: border-box;
  padding-right: 20px;

  width: 100%;

  >span{
    margin-bottom: 10px;
    font-size: .9rem;
    width: 100%;
    >div{
      text-align: left;
    }
  }

  .sub-devider{
    display: block;
    width: 100%;
    height: 1px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-top: 1px solid rgba(0,0,0,0.2);
  }
  
  .write-memo{
    >div{
      display: flex;
      flex-direction: column;
      >textarea{
        /* margin-top: 5px;  */
        margin-bottom: 5px;

        resize: none;
        width: 100%;
        height: 200px;
        overflow:auto;
        border: .5px solid #cccccc;
        border-radius: 4px;

      }
    }
  }

  .profile-basic-date{
    width: 100px;
  }
  .profile-basic-date-month{
    width: 70px;
  }

`

const AfterForm=styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  margin-bottom: 5px;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding-right: 20px;

  >div{
    margin-top: 5px;
    margin-bottom: 5px;
  }
  >textarea{
    margin-top: 5px; margin-bottom: 5px;

    resize: none;
    width: 100%;
    min-height: 300px;
    overflow: auto;
    border: 1px solid #cccccc;
    border-radius: 4px;


  }
`

const WriteEditForm=styled.div`
  
  box-sizing: border-box;
  padding-left: 10px;
  /* height: 30px; */
  display: flex;
  width: 100%;
  padding-right: 20px;
  position:relative;

  button{
    border: none;
    background-color: transparent;
    opacity: .4;
    transition: .2s;
    height: auto;
    position: absolute;
    right: 20px;
    padding: 0px;
    cursor: pointer;
    :hover{
      opacity: 1;
    }
  }

  .ras-tag{
    display: inline-block;
    font-size: 0.9rem;
    border: .5px solid rgba(0,0,0,0.2);
    border-radius: 12px;
    padding: 5px;
    padding-left: 7px;
    padding-right: 7px;
    
    margin-right: 5px;
  }

  .ras-text{
    height: 100%;
    display: inline-flex;
    align-items: center;
    width: 100%;
    /* >div{
      width: 50%;
      text-align:left; */
    >p{
      white-space: pre-line;
      margin: 0;
      text-align:left;
      width: 100%;
      height: 100%;
      max-height: 300px;
      overflow: auto;
    }
    /* } */
  }
  .ras-li{
    display: flex;
    flex-direction: column;
    width: 100%;
    position:relative;
    >div{
      position:relative;
      display: flex;
      width: 100%;
      text-align: left;
      /* margin-top: 3px; */
      margin-bottom: 3px;
      >button{
        right: 0px;
      }
    }
  }

`


const AfterBtnForm=styled.div`
  button{
    margin-right: 10px;
    border: .5px solid rgba(253,134,18, 0.8);
    background-color: rgba(253,134,18, 0.8);
    border-radius: 5px;
    transition: .2s;
    color: white;
    box-sizing: border-box;
    padding: 5px;
    padding-right: 10px;
    padding-left: 10px;
    font-weight: 600;
    cursor: pointer;

    :hover{
      background-color: rgba(253,134,18, 1);
    }

    :first-child{
      color: rgba(0,0,0,0.6);
      border: .5px solid rgba(253,134,18, 0.8);
      background-color: white;
      :hover{
        background-color: white;
        color: black;

      }
    }
    
  }

`

const AddBtn=styled.button`
  display: flex;
  width: 100%;
  height: 40px;
  border: none;
  /* background-color: transparent; */
  background-color: rgba(0,0,0,0.1);
  justify-content: center;
  border-radius: 5px;
  align-items: center;
  cursor: pointer;
  transition: .2s;

  margin-top: 10px;
  :hover{
    background-color: rgba(0,0,0,0.2);
  }
  :focus{
    background-color: rgba(0,0,0,0.3);
  }
`
